import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper, Fade, Backdrop } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface Props {
  onFinish?: () => void;
}

const SuccessAnimation: React.FC<Props> = ({ onFinish }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (onFinish) {
      const timer = setTimeout(onFinish, 2000);
      return () => clearTimeout(timer);
    }
  }, [onFinish]);

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      }}
    >
      <Fade in={true} timeout={1000}>
        <Paper
          elevation={4}
          className="glass-effect"
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 3,
            maxWidth: 400,
            mx: 2,
          }}
        >
          <Box
            className="animate-pulse"
            sx={{
              mb: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: 80,
                color: 'success.main',
                filter: 'drop-shadow(0 0 10px rgba(23, 207, 119, 0.5))',
              }}
            />
          </Box>
          <Typography
            variant="h5"
            align="center"
            sx={{ 
              fontWeight: 600,
              color: 'text.primary',
              textShadow: '0 0 10px rgba(255, 255, 255, 0.3)'
            }}
          >
            {t('registration.profileCreated')}
          </Typography>
        </Paper>
      </Fade>
    </Backdrop>
  );
};

export default SuccessAnimation;
